import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  oktaAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const authEnvironment = configApi.getOptionalString('auth.environment');

      const oktaProvider = {
        id: 'okta-auth-provider',
        title: 'Okta',
        message: (
          <>
            To be able to log in, make sure that you see Backstage app in your
            Okta dashboard.
            <br />
            <br />
            You can add it to your account here:
            <br />
            <a
              href="https://schibsted.okta.com/enduser/catalog"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              https://schibsted.okta.com/enduser/catalog
            </a>
          </>
        ) as unknown as string,
        apiRef: oktaAuthApiRef,
      };

      if (authEnvironment === 'test') {
        return (
          <SignInPage
            {...props}
            providers={[oktaProvider, 'guest']}
            align="center"
          />
        );
      }

      return (
        <SignInPage {...props} provider={oktaProvider} align="center" auto />
      );
    },
  },
});
